import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-threshold-value.ts';

const modelValueType: Record<TModelValueType, string> = {
  value: 'Statyczny',
  factoredLimit: 'Dynamiczny',
  limitMin: 'Minimum osi',
  limitMax: 'Maksymalna wartość osi',
  infinity: '+∞',
};

export default {
  modelValueType,
};
